// GET /v6/duedate/summary — the ONE read behind the Due Date Control Dashboard
// (PATTERNS.md BP-15: a dashboard is earned by a real aggregate endpoint; the
// whole page comes from one payload, and nothing is counted client-side).
import { axios } from "../api";
import type { DueDateSummary } from "./type";

const COUNT_KEYS = [
  "assigned_total",
  "templates_total",
  "open_total",
  "overdue",
  "due_7",
  "due_30",
  "no_due_date",
] as const;

/**
 * Is this the summary's shape? A 200 whose counts are not numbers is NOT a
 * dashboard of zeros — the page treats it as a failed read.
 */
export function isDueDateSummary(value: unknown): value is DueDateSummary {
  if (!value || typeof value !== "object") return false;
  const v = value as Record<string, unknown>;
  return (
    COUNT_KEYS.every((k) => typeof v[k] === "number") &&
    Array.isArray(v.overdue_items) &&
    Array.isArray(v.upcoming) &&
    Array.isArray(v.by_section) &&
    Array.isArray(v.by_assignee)
  );
}

export async function getDueDateSummary(): Promise<DueDateSummary> {
  const { data } = await axios.get<DueDateSummary>("/v6/duedate/summary", { cache: false });
  if (!isDueDateSummary(data)) {
    throw new Error("GET /v6/duedate/summary returned an unexpected shape");
  }
  return data;
}
